module.exports = __webpack_public_path__ + "static/media/mobile_info.70039835.jpg";